import { Notice } from '~/types';
import Icon from '../Icon/Icon';
import * as S from './Toast.styled';

export interface ToastProps {
  type: Notice;
  text: string;
}

export default function Toast({
  type = 'success',
  text = 'You successfully changed your password.',
}: ToastProps) {
  return (
    <S.Container>
      <S.ToastContainer type={type}>
        <S.IconBox type={type}>
          <Icon iconName='Notification' size={20} />
        </S.IconBox>
        <S.Text>
          <span>{text}</span>
        </S.Text>
      </S.ToastContainer>
    </S.Container>
  );
}
